import { useState, useCallback } from 'react';
import { message } from 'antd';
import {
  p9513Api,
  LeaveItem,
  EmpFilter,
  ApproveAction,
  ApproveResponse,
} from '../../../services/p9513Api';

export function useLeaveApproval() {
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState(false);
  const [leaves, setLeaves] = useState<LeaveItem[]>([]);
  const [total, setTotal] = useState(0);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const [filter, setFilter] = useState<EmpFilter>({ empStart: '', empEnd: '' });

  const fetchLeaves = useCallback(async () => {
    setLoading(true);
    try {
      const data = await p9513Api.getLeaves(filter);
      setLeaves(data.items);
      setTotal(data.total);
      setSelectedKeys([]);
    } catch {
      message.error('查詢請假單失敗');
    } finally {
      setLoading(false);
    }
  }, [filter]);

  const batchApprove = useCallback(
    async (action: ApproveAction, remarks: string): Promise<ApproveResponse | null> => {
      if (selectedKeys.length === 0) {
        message.warning('請先選取要處理的請假單');
        return null;
      }
      setApproving(true);
      try {
        const resp = await p9513Api.approveLeaves({
          leave_nos: selectedKeys,
          action,
          remarks,
        });
        const actionText = action === 'Y' ? '核准' : action === 'N' ? '拒絕' : '代理核准';
        message.success(`${actionText}完成：成功 ${resp.success} 筆，失敗 ${resp.failed} 筆`);
        setSelectedKeys([]);
        await fetchLeaves();
        return resp;
      } catch {
        message.error('處理請假單失敗');
        return null;
      } finally {
        setApproving(false);
      }
    },
    [selectedKeys, fetchLeaves]
  );

  return {
    loading,
    approving,
    leaves,
    total,
    selectedKeys,
    setSelectedKeys,
    filter,
    setFilter,
    fetchLeaves,
    batchApprove,
  };
}
